// extracted by mini-css-extract-plugin
module.exports = {"container":"primaryButton_container__2ydKu","primaryButton":"primaryButton_primaryButton__5zcvC"};